<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>门店管理</el-breadcrumb-item>
            <el-breadcrumb-item>器械列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20" style="margin: 20px 0;">
                <el-col :span="16">
                    <el-select v-model="queryInfo.query"  placeholder="请选择门店" @change="getInfoList"  style="width: 280px;" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8" style="display: flex;">
                    <el-button icon="el-icon-plus" type="primary" @click=" addDialogVisible = true" v-permission="'btn:store:device:add'">添加门店器械</el-button>
                    <input
                        type="file"
                        ref="fileInput"
                        accept=".xlsx, .xls"
                        @change="handleFileChange"
                        style="display: none"
                        />
                    <el-button type="primary" icon="el-icon-upload2" style="margin-left: 10px;" @click="triggerFileInput" v-permission="'btn:store:device:import'">导入门店器械</el-button>
                    <download-excel :data = "excel_data" :fields = "excel_fields" name = "门店器械模板">
                        <!-- <el-button type="primary" icon="el-icon-download" style="margin-left: 10px;">下载导入模板</el-button> -->
                         <div style="padding-top: 10px;padding-left: 10px;color: #999;cursor: pointer;">下载导入模板</div>
                    </download-excel>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--列表区域-->
            <el-table :data="infolist" :key="infolist.index" style="width: 100%" stripe size="middle" height="700">

                <el-table-column label="ID" type="index"  width="50"></el-table-column>
                <el-table-column label="门店名称" prop="storename"  width="300"></el-table-column>
                <el-table-column label="器械类别" prop="classname"  width="200"></el-table-column>
                <el-table-column label="器械数据" prop="devicedata"  width="800"></el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="success" icon="el-icon-edit" size="mini" @click="EditInfo(scope.row.id)"></el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加对话框-->
            <el-dialog title="添加门店器械" :visible.sync="addDialogVisible" width="60%" top="150px" @close="addDialogClosed">
                <div style="height: 500px;overflow-y: auto">
                    <el-form :model="addForm" :rules="addFormRules" ref="addFormRef"  label-width="100px">
                        <el-form-item label="选择门店" prop="storeid">
                            <el-select v-model="addForm.storeid"  placeholder="请选择门店"  style="width: 280px;" clearable filterable>
                                <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择类别" prop="classid">
                            <el-select v-model="addForm.classid"  placeholder="请选择器械类别"  style="width: 280px;" clearable>
                                <el-option v-for="item in classlist" :key="item.id" :label="item.classname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-for="(owner, index) in addForm.owners"
                            :label="'器械名称' + (index + 1)"
                            :key="owner.key"
                            :prop="'owners.' + index + '.devicename'"
                            :rules="{ required: true, message: '器械名称不能为空', trigger: 'blur' }">
                            <el-input v-model="owner.devicename" placeholder="名称" style="width: 300px; margin:0 10px ;"></el-input>
                            <el-input-number v-model="owner.devicenumber" :min="1" style="margin:0 10px ;"></el-input-number>
                            <el-button @click.prevent="removeOwner(owner)">删除</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addOwner">新增器械</el-button>
                    <el-button @click="AddInfo" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加对话框-->
            <!-- 编辑对话框 -->
            <el-dialog title="编辑门店器械" :visible.sync="editDialogVisible" width="60%" top="50px" @close="editDialogClosed">
                <div style="height: 500px;overflow-y: auto">
                    <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px">
                        <el-form-item label="选择门店" prop="storeid">
                            <el-select v-model="editForm.storeid"  placeholder="请选择门店"  style="width: 280px;" clearable disabled>
                                <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择类别" prop="classid">
                            <el-select v-model="editForm.classid"  placeholder="请选择器械类别"  style="width: 280px;" clearable disabled>
                                <el-option v-for="item in classlist" :key="item.id" :label="item.classname" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                            <el-form-item
                                v-for="(owner, index) in editForm.devicedata"
                                :label="'器械名称' + (index + 1)"
                                :key="owner.key"
                                :prop="'devicedata.' + index + '.devicename'"
                                :rules="{ required: true, message: '器械名称不能为空', trigger: 'blur' }">
                                <el-input v-model="owner.devicename" placeholder="名称" style="width: 300px; margin:0 10px ;"></el-input>
                                <el-input-number v-model="owner.devicenumber" :min="1" style="margin:0 10px ;"></el-input-number>
                                <el-button @click.prevent="removeOwner1(owner)">删除</el-button>
                            </el-form-item>
                        
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer" style="margin:0">
                    <el-button @click="addOwner1">新增器械</el-button>
                    <el-button @click="EditInfoSave" style="background:#19aa8d;color:#fff">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="导入门店器械" :visible.sync="importDialogVisible" width="60%" top="150px">
                    <el-select v-model="storeid" filterable  placeholder="请选择门店"  style="width: 280px;margin-left: 70px;margin-bottom: 20px;" clearable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-table :data="formattedTableData" stripe size="middle" height="500" style="width: 90%; margin: 0 auto;">
                    <el-table-column
                        prop="category"
                        label="器械类别"
                        ></el-table-column>
                        <el-table-column
                        prop="name"
                        label="器械名称"
                        ></el-table-column>
                        <el-table-column
                        prop="value"
                        label="器械数量"
                        ></el-table-column>
                    </el-table>
                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="importDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmImport" v-permission="'btn:store:device:import:confirm'">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
export default {
    data() {
        return{
            imgURL:this.GLOBAL.imgURL,
            uploadurl: this.GLOBAL.imgURL+'upload/',
            limitNum: 1,
            fileList:[],
            infolist: [],
            addDialogVisible:false,
            editDialogVisible:false,
            importDialogVisible:false,
            tag: false,
            //获取列表的参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 20
            },
            total: 0,
            //添加表单数据
            addForm:{
                storeid:'',
                classid:'',
                owners: [
                    {
                        devicename: '',
                        devicenumber:'',
                        key: Date.now()
                    }
                ]
                
            },
            editForm: {},

            //添加表单验证规则
            addFormRules:{
                storeid:[
                    { required: true, message: '请选择门店', trigger: 'change' }
                ],
                classid:[
                    { required: true, message: '请选择类别', trigger: 'change' }
                ]
            },
            editFormRules:{
                title:[
                    { required: true, message: '请输入轮播图标题', trigger: 'blur' }
                ]
            },
            storelist:[],
            classlist:[],
            storeid:'',
            tableData: [],      // 原始二维数组
            formattedTableData: [], // 格式化后的对象数组
            headers: ['器械类别', '器械名称', '器械数量'], // 假设表头为这三列
            excel_fields: {  //导出Excel表格的表头设置
                '器械类别': 'classname',
                '器械名称': 'devicename',
                '器械数量': 'devicecount'
            },
            excel_data:[
                {"classname":"有氧器械","devicename":"爬楼机","devicecount":10},
                {"classname":"有氧器械","devicename":"跑步机","devicecount":10},
                {"classname":"无氧器械","devicename":"瑜伽垫","devicecount":6},
                {"classname":"无氧器械","devicename":"跳绳","devicecount":4},
                {"classname":"力量器械","devicename":"坐姿推胸","devicecount":2},
                {"classname":"力量器械","devicename":"坐姿举肩","devicecount":3}
            ]
        }
        
    },
    mounted(){
        this.getInfoList()   
        this.getStoreList()
        this.getClassList()
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token') 
    },
    computed:{
        
    },
    methods:{
        async getStoreList(){
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data
        },
        async getClassList(){
            const { data: res } = await this.$http.get('deviceclass/')
            this.classlist = res.data
        },
        async getInfoList() {

            const { data: res} = await this.$http.get('devicelist/',{ params: this.queryInfo })

            if(res.status == 1){
                 this.total = res.data.totalCount;
                 this.infolist = res.data.list.map(v => {
                 return v.fields
                 })
             }
             for (let index = 0; index < res.data.list.length; index++) {
                     this.infolist[index].id= res.data.list[index].pk;
                 }
            
         },
        addPic(file, fileList){
            this.addForm.pic = file.picname
        },
        editPic(file, fileList){
            this.editForm.pic = file.picname
        },
        addOwner() {
            this.addForm.owners.push({
                devicename: '',
                devicenumber:'',
                key: Date.now()
            })
        },
        removeOwner(item) {
            const index = this.addForm.owners.indexOf(item);
            if (this.addForm.owners.length > 1 && index !== -1) {
                this.addForm.owners.splice(index, 1);
            }
        },
        addOwner1() {
            this.editForm.devicedata.push({
                devicename: '',
                devicenumber:'',
                key: Date.now()
            })
        },
        removeOwner1(item) {
            const index = this.editForm.devicedata.indexOf(item);
            if (this.editForm.devicedata.length > 1 && index !== -1) {
                this.editForm.devicedata.splice(index, 1);
            }
        },
        AddInfo(){
            this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                    const { data:res } = await this.$http.post('deviceadd/', this.addForm)
                    if(res.status===0)
                    {
                        this.$message.success('添加成功！')
                        this.addDialogVisible = false
                        this.addForm.owners = [{
                            devicename: '',
                            devicenumber:'',
                            key: Date.now()
                        }]
                        this.getInfoList()
                    }else{
                        this.$message.error(res.message || '操作失败')
                    }
            })
        },
        async EditInfo(id){
            const { data: res } = await this.$http.get('deviceinfo/' + id)
            this.editForm = res.data
            
            const validJsonStr = res.data.devicedata.replace(/'/g, '"');
            this.editForm.devicedata = JSON.parse(validJsonStr)
            this.editForm.admin_token =window.sessionStorage.getItem('admin_token')

            this.editDialogVisible = true
            
        },
        EditInfoSave(){
            
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const { data: res } = await this.$http.post('deviceedit/' + this.editForm.id,this.editForm)
                if (res.status === 0) {
                    this.$message.success('信息修改成功')
                    this.editDialogVisible = false
                    this.getInfoList()
                }
            })
        },
        async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('devicedel/'+ id,{ params:{admin_token:this.addForm.admin_token} })
            
                if (res.status === 0) { 
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getInfoList()
        },
        
        handleSizeChange(newSize){
            this.queryInfo.pagesize = newSize
            this.getInfoList()
        },
        handleCurrentChange(newPage){
            this.queryInfo.pagenum = newPage
            this.getInfoList()
        },
        addDialogClosed(){
                this.$refs.addFormRef.resetFields()
        },
        editDialogClosed(){
                this.$refs.editFormRef.resetFields()
        },
        triggerFileInput() {
            this.$refs.fileInput.click()
        },
        handleFileChange(e) {
            const files = e.target.files
            if (files.length === 0) return
            
            const file = files[0]
            
            this.readExcel(file)
        },
        readExcel(file) {
            const reader = new FileReader()
            
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result)
                const workbook = XLSX.read(data, { type: 'array' })
                
                // 默认读取第一个工作表
                const firstSheetName = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[firstSheetName]
                
                // 转换为 JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
                
                if (jsonData.length > 0) {
                    this.tableData = jsonData.slice(1) // 其余行作为数据
                    // 转换为对象数组
                    this.formattedTableData = this.tableData.map(row => ({
                        category: row[0], // 第一列作为分类
                        name: row[1],     // 第二列作为名称
                        value: row[2]     // 第三列作为数值
                    }))
                    this.importDialogVisible = true
                }

            }
            
            reader.readAsArrayBuffer(file)
        },
        async confirmImport() {
            // 在这里可以处理导入确认逻辑
            // this.$emit('import-success', this.formattedTableData)
            if(this.storeid == ""){
                this.$message.error('请选择所属门店')
                return
            }
            const { data:res } = await this.$http.post('deviceimport/',{admin_token:this.addForm.admin_token,tabledata:this.formattedTableData,storeid:this.storeid})
            if(res.status===0)
            {
                this.$message.success('导入成功！')
                this.importDialogVisible = false
                // 清空文件输入
                this.$refs.fileInput.value = ''
                this.getInfoList()
            }
            
        }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    /deep/.el-dialog__body{
        padding-bottom:0px !important;
    }
</style>